export default __webpack_public_path__ + "static/N0253-54b7c283e363de724717a75472fabffc.png";